var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSulfites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sulfur Dioxide &amp; Sulphites") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sulfur-Dioxide-&-Sulphites",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,10.0731368 L11,3 L14,3 L14,10 L19.0439766,17.926249 C19.6369929,18.8581318 19.3622874,20.0943067 18.4304047,20.687323 C18.1095028,20.8915333 17.7370217,21 17.3566537,21 L7.65644946,21 C6.55187996,21 5.65644946,20.1045695 5.65644946,19 C5.65644946,18.6175735 5.76609246,18.2431642 5.97238319,17.9211484 L11,10.0731368 Z M7.85,15 L17.2,15 L19.0556007,17.9298958 C19.6466029,18.8630572 19.3692281,20.0986359 18.4360667,20.6896382 C18.1159656,20.8923688 17.7448615,21 17.3659625,21 L7.65966337,21 C6.55509387,21 5.65966337,20.1045695 5.65966337,19 C5.65966337,18.6170702 5.76959488,18.2421898 5.9763955,17.9199031 L7.85,15 Z M10,3 L15,3",
    id: "Combined-Shape",
    stroke: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSulfites);
export default __webpack_public_path__ + "static/media/sulfites.d7697a9da2a7d4cfd47a5bd77411f382.svg";
export { ForwardRef as ReactComponent };